import { Nullable } from '@models/EquipmentInventory.model';
import { MaybeUndef } from '../../models/Tag.model';

export function nullToUndef<T>(value: Nullable<T>): MaybeUndef<T> {
  return value ?? undefined;
}
